export default __webpack_public_path__ + "static/media/potato2.5c64d83a.png";